module.exports = __webpack_public_path__ + "media/svg/company_light_solo-bc01ced1.svg";